import { render, staticRenderFns } from "./IosGoods.vue?vue&type=template&id=8c572636&scoped=true"
import script from "./IosGoods.vue?vue&type=script&lang=js"
export * from "./IosGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c572636",
  null
  
)

export default component.exports